import React, {useContext} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {FormFieldConfigSize} from '../../../../../src/@types/components/Form';
import FormErrorMessage from '../../../../../src/components/Form/FormErrorMessage';
import {FormDataProviderAPIContext} from '../../../../../src/contexts/FormDataProviderAPIContext';
import {IOrderModel} from '../../../../../src/@interfaces/models/Order/IOrderModel';
import CustomSelect from '../../../../../src/components/Fields/CustomSelect';
import Translate from '../../../../../src/components/Translate/Translate';
import classnames from '../../../../../src/helpers/classnames';

export default function OrderProductField(props: {
    formId: string,
    products: IOrderModel['products'],
    isDisabled?: boolean,
}) {
    const {control} = useFormContext();
    const {modelOptions} = useContext(FormDataProviderAPIContext) ?? {};

    const options = (options => {
        return props?.products?.map(product => {
            return {
                value: product.id,
                label: `${product.id} | ${
                        product.product ?
                                product.product.title :
                                options?.find(i => i.value === product.id)?.label ?? 'unknown'
                }`
            };
        }) ?? [];
    })(modelOptions?.products);

    return <Controller
            name="order_product_id"
            control={control}
            render={(
                    {
                        field: {name, value, onChange, onBlur},
                        fieldState: {error}
                    }
            ) => {
                return <>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.fields.order_product_id"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <CustomSelect
                            label="TaskForm.fields.order_product_id"
                            size={FormFieldConfigSize.SM}
                            className={classnames({'is-invalid': error})}
                            isInvalid={Boolean(error)}
                            name={name}
                            value={value}
                            disabled={props.isDisabled || !options}
                            options={options ?? []}
                            onChange={onChange}
                            onBlur={onBlur}
                            formId={props.formId}
                            menuPortalTarget={document.body}
                    />

                    <FormErrorMessage fieldName="payload.status_id"/>
                </>;
            }}
    />;
}
